import { CDN_URL } from "@/constants";

export function getHeroPath(user, HEROES_NEW) {
  const hero = user?.selectedHero;
  const enrichedHero = HEROES_NEW?.find((h) => h.id === hero.templateId);
  return `${CDN_URL}${enrichedHero?.pvePath}`;
}
